import { AuthenticationService } from '../_services/authentication/authentication.service';
import { EMPTY } from 'rxjs';
import { catchError, finalize, switchMap, timeout } from 'rxjs/operators';

export function initializeApp(authService: AuthenticationService) {
  return new Promise<void>((resolve) => {
    if (localStorage.getItem('refresh_token') || authService.isLoggedIn()) {
      authService
        .refreshToken()
        .pipe(
          timeout(8000),
          switchMap(() => authService.loadContext().pipe(timeout(8000))),
          // Renewal owns invalid-session cleanup. Network and context errors
          // must leave the stored credentials available for reconnection.
          catchError(() => EMPTY),
          finalize(resolve)
        )
        .subscribe();
    } else {
      try {
        authService.closeSession();
      } finally {
        resolve();
      }
    }
  });
}
